import React, { useEffect, useState } from 'react'
import {Form, FormGroup, Button} from 'react-bootstrap';
import { login } from '../api/api';


const Login = () => {

    const [data, setData ] = useState({email: '', password: ''});

    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }

    const handleSubmit = async (e) => {
      e.preventDefault()
      // console.log('form submitted.');
      // console.log(data);
      const response = await login(data);
      console.log(response);

    }

    useEffect(() => {
        console.log(window.innerWidth);
    }, [])
  return (
    <div id='lgbody' className='row login m-1 p-1'
    >
      
      <div
      className='col-lg-4 col-md-5 col-sm-6 col-xs-8 col-xxs-10 card p-2'
      >

    
        <Form  
        method='post'
        onSubmit={e => handleSubmit(e)}
        >
          <h2 className='text-center'> Login</h2>
          <Form.Label> Email/Username </Form.Label>
          <FormGroup>
              
              <Form.Control type='text' placeholder='enter email or username'
              name='email'
              value={data.email}
              onChange={ (e) => {handleChange(e)}}
              />
          </FormGroup>
          <Form.Label> Password </Form.Label>
          <FormGroup>
              
              <Form.Control type='password' placeholder='enter password' 
              name='password'
              value={data.password}
              onChange={ (e) => {handleChange(e)}}
              />
          </FormGroup>
          <center>
          <Button type='button' size='lg' variant='dark' className='w-50 mt-3'
          onClick={() => {
            window.start_load = function(){
              let element = document.createElement('div');
              element.id = 'preloader2';
              document.getElementById('lgbody').appendChild(element);
              setTimeout(() => {
                  element.remove();
              }, 3000)

            }
            window.start_load();
          }}
          > Login </Button>
          </center>
        </Form>
        <div className='d-flex justify-content-between'>
            <a href='#'> Website</a>
            <a href='#'> Developers Doc</a>
        </div>
      </div>
    </div>
  )
}

export default Login
